import styled from '@emotion/styled';

const S = {};

S.LogoButton = styled.div`
  label: LogoButton;

  flex: 0 1 8rem;
  min-width: 7.1875rem;
`;

S.Logo = styled.img`
  label: Logo;

  max-width: 100%;
`;

export default S;
